import { isBitramp, isSNS } from "@/utils/utils";
import React from "react";
import bgSNS from "../assets/SVG/bgSNS.svg";
import loader_SNS from "../assets/SVG/SNS_loading.json";
import { Player } from "@lottiefiles/react-lottie-player";
import loader_bitramp from "../assets/SVG/Trail_loading.json";

const Loader: React.FC = () => {
  return isBitramp() ? (
    <div className="loader__center">
      <Player
        autoplay={true}
        loop={true}
        src={loader_bitramp}
        style={{
          height: "6rem",
          width: "6rem",
          transform: "rotate(90deg)",
        }}
      />
    </div>
  ) : isSNS() ? (
    <div
      className="loader__center !min-h-screen !bg-[#1C1C1C] !w-full"
      style={{
        backgroundImage: `url(${bgSNS})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Player
        autoplay={true}
        loop={true}
        src={loader_SNS}
        style={{
          height: "6rem",
          width: "6rem",
          transform: "rotate(90deg)",
        }}
      />
    </div>
  ) : (
    <div className="loader__center">
      <div className="push-pop">
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Loader;
